<template>
  <div class="new-invoice pb-9">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <!-- delete-dialog -->
    <v-dialog v-model="deleteModal" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از حدف محصول {{ selectedItem.name }} اطمینان دارید؟
          </span>
        </h5>
        <div class="text-left mt-9">
          <v-btn
            class="purple-mainBtn"
            width="90"
            @click="removeItem(selectedIndex, selectedItem)"
            >بله</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2"
            width="90"
            @click="deleteModal = false"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n</v-btn
          >
          <b>افزودن مشتری جدید</b>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-btn
      color="primary"
      style="float: right"
      @click="openAddCustomer()"
      v-shortkey.once="['n']"
      @shortkey="openAddCustomer()"
      hidden
    >
      ثبت مشتری جدید +
    </v-btn>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">پیش‌فاکتور جدید</h4>
      </div>
      <hr class="mt-5" />

      <h4 class="c-purple mt-12">ثبت پیش‌فاکتور جدید</h4>
      <div class="d-flex flex-sm-row flex-column mt-5 ps-0 flex-wrap">
        <div class="custom-input d-flex flex-row ps-3 pe-3">
          <v-text-field
            outlined
            dense
            hide-details
            type="number"
            dir="ltr"
            label="شماره همراه مشتری"
            @keyup.enter="customerMobile ? searchCustomer() : ''"
            v-model="customerMobile"
          >
            <template v-slot:append>
              <span @click="searchCustomer()">
                <v-icon>mdi-magnify</v-icon></span
              >
            </template>
          </v-text-field>

          <v-btn
            @click="searchCustomer()"
            class="blue-mainBtn ms-2"
            height="42"
            :disabled="!customerMobile"
          >
            جستجو
          </v-btn>
        </div>
        <div>
          <div class="customSelect ms-3">
            <v-autocomplete
              attach
              :menu-props="{ bottom: true, offsetY: true }"
              @change="getBalance(newInvoice.shopCustomerId)"
              auto-select-first
              hide-details=""
              no-data-text="نتیجه‌ای یافت نشد!"
              v-model="newInvoice.shopCustomerId"
              :items="customers"
              item-text="name"
              item-value="id"
              class="mb-3 mt-sm-0 mt-2 me-sm-0 me-4 shop-select"
              label="نام مشتری"
              :loading="gettingCustomers"
              :disabled="gettingCustomers"
              dense
              outlined
            >
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <!--<img
                  v-if="data.item.royaltyTier"
                  :src="computedIcon(data.item)"
                  style="height: 26px; width: 26px"
                  class="me-1"
                />-->
                {{ data.item.name }}
              </template>
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <!--<img
                  v-if="data.item.royaltyTier"
                  :src="computedIcon(data.item)"
                  style="height: 26px; width: 26px"
                  class="me-1"
                />-->
                {{ data.item.name }}
              </template>
            </v-autocomplete>
          </div>
        </div>
      </div>
      <div
        v-if="gettingBalance"
        class="pa-5 d-flex justify-center align-center"
      >
        <v-progress-circular indeterminate color="purple"></v-progress-circular>
      </div>
      <div
        v-if="newInvoice.shopCustomerId && !gettingBalance"
        class="customer-info grey--text text--darken-2 mt-6 mb-3"
      >
        <v-row>
          <v-col>
            <b class="me-1">مانده حساب:</b>
            <span v-if="newInvoice.customerBalance" class="ms-2">{{
              newInvoice.customerBalance
            }}</span>
          </v-col>
          <v-col>
            <b class="me-1">مبلغ کل پرداختی‌های پیشین:</b>
            {{ Number(allShopIncomeBalance).toLocaleString() }} ریال
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col>
            <b class="me-1">نوع اعتبار:</b> {{ royaltyCreditType }}
          </v-col> -->
          <!-- <v-col>
            <b class="me-1">میزان اعتبار باقی مانده:</b>
            {{ Number(royaltyCreditAmount).toLocaleString() }} ریال
          </v-col> -->
        </v-row>
      </div>

      <hr />
      <v-btn
        @click="
          titleFilter = '';
          productsDialog = true;
        "
        height="50"
        class="purple-borderedBtn w-100"
        :class="!newInvoice.shopCustomerId ? 'disabled' : ''"
        ><v-icon class="me-2">$Box</v-icon> افزودن کالا
      </v-btn>
      <span v-show="false">{{ reactivity }}</span>
      <div class="custom-table dashed mt-8 pb-2">
        <b-table
          responsive
          show-empty
          :items="selectedProducts"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="هنوز کالایی به فاکتور اضافه نشده است"
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
          :current-page="productCurrentPage"
          :per-page="productPerPage"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="mt-2"
            >
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است</span
              >
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:head(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + productPerPage * (productCurrentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div
              style="
                text-align: center;
                vertical-align: middle;
                min-width: 300px;
              "
            >
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(price)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ Number(data.value).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(amount)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="d-flex flex-row justify-space-around"
            >
              <div class="d-flex">
                <div
                  class="add-btn ms-1"
                  @click="addItem(data.item, 100, 'direct')"
                  dir="ltr"
                >
                  <span>+100</span>
                </div>
                <div
                  class="add-btn ms-1"
                  @click="addItem(data.item, 10, 'direct')"
                  dir="ltr"
                >
                  <span>+10</span>
                </div>
                <div
                  class="add-btn ms-1"
                  @click="addItem(data.item, 1, 'direct')"
                  dir="ltr"
                >
                  <span>+1</span>
                </div>
              </div>
              <span style="padding: 2px 4px 0">{{ data.value }}</span>
              <div v-if="data.value == 1">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <span
                    class="pointer"
                    @click="
                      openDeleteModal(
                        data.index + productPerPage * (productCurrentPage - 1),
                        data.item
                      )
                    "
                  >
                    <v-icon>$Delete</v-icon></span
                  >
                </div>
              </div>
              <div v-else class="d-flex">
                <div
                  class="remove-btn"
                  @click="reduceItem(data.item, data.index, 1)"
                  dir="ltr"
                >
                  <span>-1</span>
                </div>
                <div
                  class="remove-btn ms-1"
                  @click="reduceItem(data.item, data.index, 10)"
                  dir="ltr"
                  v-if="data.value > 10"
                >
                  <span>-10</span>
                </div>
                <div
                  class="remove-btn ms-1"
                  @click="reduceItem(data.item, data.index, 100)"
                  dir="ltr"
                  v-if="data.value > 100"
                >
                  <span>-100</span>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell(totalPrice)="data">
            <div style="text-align: center; vertical-align: middle">
              <span v-show="false">{{ reactivity }}</span>
              {{
                (Number(data.item.amount) * data.item.price).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <span
                class="pointer"
                @click="
                  openDeleteModal(
                    data.index + productPerPage * (productCurrentPage - 1),
                    data.item
                  )
                "
              >
                <v-icon>$Delete</v-icon></span
              >
            </div>
          </template>
        </b-table>
        <div v-if="selectedProducts.length">
          <v-row class="mt-6">
            <v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box-new">
                  <v-select
                    class="shop-select"
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    outlined
                    dense
                    v-model="productPerPage"
                    :items="perPageOptions"
                    @change="productCurrentPage = 1"
                  ></v-select>
                </div>
              </v-col>
            </v-col>
            <v-col>
              <div>
                <v-pagination
                  v-model="productCurrentPage"
                  :length="Math.ceil(selectedProducts.length / productPerPage)"
                  :total-visible="5"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  class="float-end"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
          <hr class="my-8" />
          <v-row>
            <v-col lg="6" md="12" cols="12">
              <!-- <div class="mb-7" v-if="Number(royaltyCreditAmount) > 0">
                <span
                  @click="
                    newInvoice.useCredit = !newInvoice.useCredit;
                    newInvoice.discount = 0;
                  "
                  class="pointer"
                >
                  <v-icon v-if="newInvoice.useCredit"> $Purplechecked </v-icon>
                  <v-icon v-else> $PurpleUnchecked </v-icon>
                  <span
                    class="ms-3"
                    :class="
                      !newInvoice.useCredit
                        ? 'grey--text text--darken-2'
                        : 'c-purple font-weight-bold'
                    "
                    >استفاده از مبلغ اعتبار</span
                  >
                </span>
              </div> -->
              <div class="custom-input mb-7">
                <!--<v-row class="mt-0">
                  <v-col cols="6">
                    <v-checkbox
                      v-if="false"
                      v-model="useRoyaltyCredit"
                      label="استفاده از اعتبار"
                      class="mt-0 royaltyCredit"
                    ></v-checkbox>
                  </v-col>
                </v-row>-->
                <vuetify-money
                  label="تخفیف (ریال)"
                  :disabled="disableDiscount()"
                  v-model="newInvoice.discount"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  hide-details
                  type="number"
                  outlined
                  dense
                />
              </div>
              <div class="custom-input mb-7">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                  label="مالیات (درصد)"
                  class="w-100"
                  v-model="newInvoice.vat"
                ></v-text-field>
                <span id="expirationDate">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-edit"
                    v-model="newInvoice.expirationDate"
                    label="تاریخ انقضا"
                    :editable="true"
                    class="date-input mt-5"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="newInvoice.expirationDate"
                  element="expirationDate"
                  color="#9c7fb7"
                />
              </div>
            </v-col>
            <v-col lg="6" md="12" cols="12">
              <div class="custom-input mt-0">
                <v-textarea
                  :rows="royaltyCreditAmount == 0 ? 5 : 7"
                  no-resize
                  dense
                  outlined
                  hide-details
                  label="توضیحات"
                  v-model="newInvoice.descrition"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
          <hr class="my-8" />
          <v-row class="c-grey" style="font-size: 17px">
            <v-col lg="6" md="12" cols="12">
              <v-row>
                <v-col>
                  <span> قیمت کل </span>
                </v-col>
                <v-col>
                  {{ Number(computedTotalPrice).toLocaleString() + " ریال " }}
                </v-col>
              </v-row>
              <v-row v-if="!newInvoice.useCredit">
                <v-col>
                  <span> تخفیف </span>
                </v-col>
                <v-col>
                  {{ Number(newInvoice.discount).toLocaleString() + " ریال " }}
                </v-col>
              </v-row>
              <!--<v-row v-if="newInvoice.useCredit">
                <v-col>
                  <span> مبلغ اعتبار </span>
                </v-col>
                <v-col>
                  {{ Number(royaltyCreditAmount).toLocaleString() + ' ریال ' }}
                </v-col>
              </v-row>-->
              <v-row>
                <v-col>
                  <span> مالیات (ریال) </span>
                </v-col>
                <v-col>
                  {{
                    parseInt(
                      ((selectedProducts
                        .map((x) => Number(x.price) * Number(x.amount))
                        .reduce((a, b) => a + b, 0) -
                        newInvoice.discount) *
                        newInvoice.vat) /
                        100
                    ) > 0
                      ? parseInt(
                          ((selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) -
                            newInvoice.discount) *
                            newInvoice.vat) /
                            100
                        ).toLocaleString() + " ریال "
                      : 0
                  }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr class="mt-8 mb-4" />
          <v-row class="c-grey my-4" style="font-size: 19px">
            <v-col lg="6" md="12" cols="12" class="pb-0">
              <v-row>
                <v-col>
                  <span> مبلغ قابل پرداخت</span>
                </v-col>
                <v-col v-if="!newInvoice.useCredit && !isPartial">
                  {{
                    !computedDiscount
                      ? "مبلغ کل فاکتور منفی شده است."
                      : computedDiscount
                  }}
                </v-col>
                <v-col v-else-if="newInvoice.useCredit && !isPartial">
                  {{
                    royaltyCreditAmount >
                    selectedProducts
                      .map((x) => Number(x.price) * Number(x.amount))
                      .reduce((a, b) => a + b, 0) *
                      (1 + Number(this.newInvoice.vat) / 100)
                      ? 0
                      : parseInt(
                          (selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) -
                            Number(royaltyCreditAmount)) *
                            (1 + Number(this.newInvoice.vat) / 100)
                        ).toLocaleString() + " ریال "
                  }}
                  + ریال
                </v-col>
                <v-col v-else-if="isPartial">
                  {{ Number(partialAmount).toLocaleString() + " ریال " }}
                </v-col>
              </v-row>
            </v-col>
            <v-col class="text-left pb-0">
              <v-btn
                @click="addInvoice()"
                class="purple-mainBtn"
                width="90"
                :loading="addBusy"
              >
                <span class="white--text">
                  <v-icon small class="white--text me-1"
                    >mdi-check-outline</v-icon
                  >
                  ثبت
                </span></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="2000" color="green" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-check-decagram</v-icon>
        {{ text }}
      </div>
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" timeout="2000" color="red" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-alert-circle-outline</v-icon>
        موجودی انبار کافی نیست!
      </div>
    </v-snackbar>
    <v-dialog v-model="productsDialog" width="700" persistent>
      <v-card class="dialog-card">
        <div>
          <div class="d-flex flex-row justify-space-between pa-3">
            <div class="d-flex flex-row">
              <h4 class="mb-0 pt-2">محصولات</h4>
              <v-divider class="me-10 ms-10" vertical></v-divider>
              <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در عناوین محصولات..."
                  prepend-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="titleFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="titleFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        titleFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <v-divider class="me-10 ms-10" vertical></v-divider>
              <!-- <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در شماره بارکد..."
                  prepend-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="barcodeFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="barcodeFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        barcodeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div> -->
            </div>
            <span class="pointer" @click="productsDialog = false"
              ><v-icon class="close-icon me-5 mt-2">$Close</v-icon></span
            >
          </div>
          <hr />
          <div
            v-if="productsLoading"
            class="d-flex flex-column align-items-center mt-8 py-6"
          >
            <cube></cube>
            <span style="font-size: 16px">در حال بارگذاری ...</span>
          </div>
          <div v-else class="custom-table mt-5">
            <b-table
              responsive
              show-empty
              stacked="sm"
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedProducts"
              :fields="productsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(name)="data">
                <div style="text-align: right; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="
                    text-align: right;
                    vertical-align: middle;
                    min-width: 200px;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(sum)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    margin-top: -4px;
                  "
                >
                  <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                    اتمام موجودی
                  </div>
                  <div v-else>{{ data.value }}</div>
                </div>
              </template>

              <template v-slot:cell(operation)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    @click="addItem(data.item, 1, 'indirect')"
                    class="purple-mainBtn"
                    >افزودن به فاکتور</v-btn
                  >
                </div>
              </template>
            </b-table>
            <div class="blue-custom-pagination mt-6">
              <v-pagination
                v-model="currentPage"
                :length="Math.ceil(computedProducts.length / perPage)"
                :total-visible="5"
                prev-icon="$ArrowLeft"
                next-icon="$ArrowRight"
                class="float-end"
              ></v-pagination>
            </div>
          </div>
          <hr />
          <div class="py-1">
            <div v-if="!selectedProducts.length">
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است.</span
              >
            </div>
            <div v-else>
              <v-icon class="purple-icon c-purple me-3">$BoxChecked</v-icon>
              <span class="c-purple"
                >{{
                  selectedProducts
                    .map((x) => Number(x.amount))
                    .reduce((a, b) => a + b, 0)
                }}
                کالا به فاکتور اضافه شد.</span
              >
              <v-btn
                @click="productsDialog = false"
                class="purple-borderedBtn ms-10"
                >دیدن فاکتور</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCustomerDialog" width="700">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت مشتری جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newCustomerDialog = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="نام مشتری"
                v-model="newCustomer.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="شماره موبایل"
                :loading="busy"
                v-model="newCustomer.mobile"
              ></v-text-field>
              <div v-if="newCustomer.mobile">
                <phoneNumber :number="newCustomer.mobile" v-slot="{ isValid }">
                  <div
                    v-if="!isValid"
                    style="vertical-align: middle"
                    class="text--right"
                  >
                    <v-icon class="red--text me-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text">شماره موبایل معتبر نیست</span>
                  </div>
                </phoneNumber>
              </div>
            </v-col>
            <v-col cols="12">
              <v-select
                attach
                class="shop-select"
                :menu-props="{ bottom: true, offsetY: true }"
                label="نوع مشتری"
                :items="customerTypes"
                v-model="newCustomer.type"
                :loading="busy"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left py-5 ps-4 pe-4">
          <v-btn
            @click="newCustomerDialog = false"
            class="red-borderedBtn ms-2 me-2"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addCustomer()"
            class="purple-mainBtn white--text"
            width="90"
            :disabled="
              !(newCustomer.name && newCustomer.mobile && newCustomer.type)
            "
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <div id="preInvoiceReceipt" v-show="false">
      <PreInvoicePrint :invoiceData="invoiceData" />
    </div>
  </div>
</template>

<script>
import Axios from "axios";
// import VueBarcode from "vue-barcode";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import prices from "../../mixins/prices";
import PreInvoicePrint from "../../components/PreInvoicePrint.vue";

export default {
  components: {
    // barcode: VueBarcode,
    datePicker: VuePersianDatetimePicker,
    PreInvoicePrint,
  },
  mixins: [prices],
  data() {
    return {
      selectedIndex: "",
      selectedItem: {},
      deleteModal: false,
      type: "newinvoice",
      instituteName: true,
      instituteLogo: true,
      nationalCode: true,
      subDescription: true,
      signature: true,
      invoiceNumber: true,
      isPartial: false,
      partialAmount: null,
      useRoyaltyCredit: false,
      tab: "tab1",

      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],

      moment: moment,
      getReceiptDialog: false,
      guide: false,
      reactivity: false,
      snackbar: false,
      errorSnackbar: false,
      busy: false,
      text: "",
      customers: [],
      products: [],
      selectedProducts: [],
      newCustomer: {},
      cheque: {},
      titleFilter: "",
      //   barcodeFilter: "",
      perPage: 5,
      currentPage: 1,
      productsDialog: false,
      productsLoading: false,
      gettingCustomers: false,
      newCustomerDialog: false,
      customerMobile: null,
      receiptNumber: "",
      royaltyCreditAmount: null,
      allShopIncomeBalance: null,
      royaltyCreditType: "none",
      newInvoice: {
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
        paymentType: "",
        vat: 0,
        discount: 0,
        useCredit: false,
        shopInvoiceId: "",
        expirationDate: moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD"),
      },
      gettingBalance: false,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      paymentMethods: [
        { value: "use", text: "استفاده شود" },
        { value: "noUse", text: "استفاده نشود" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
        { key: "operation", label: "عملیات" },
      ],
      receiptFields: [
        { key: "index", label: "ردیف" },
        { key: "warehouse", label: "انبار" },
        { key: "code", label: "کد کالا" },
        { key: "name", label: "شرح کالا" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "جمع کل (ریال)" },
      ],
      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت (ریال)" },
        { key: "sum", label: "موجودی انبار" },
        // { key: "barcode", label: "بارکد" },
        { key: "operation", label: "عملیات" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      recipientCardNumber: "",
      buyerCardNumber: "",
      addBusy: false,
      productPerPage: 10,
      productCurrentPage: 1,
      perPageOptions: [4, 10, 20],
      preInvoiceSelectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
      ],
      invoiceData: {},
    };
  },
  methods: {
    openDeleteModal(index, item) {
      this.selectedIndex = index;
      this.selectedItem = item;
      this.deleteModal = true;
    },
    disableDiscount() {
      if (this.useRoyaltyCredit) {
        this.newInvoice.discount = 0;
        return true;
      }
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.guide = false;
      this.newCustomerDialog = true;
    },
    addItem(item, amount, type) {
      if (item.sum > 0) {
        let myIndex = this.selectedProducts.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.selectedProducts[myIndex].amount =
            Number(this.selectedProducts[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        if (type == "indirect") {
          this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    removeItem(index, item) {
      this.selectedProducts.splice(index, 1);
      this.products.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
        }
      });
      this.productCurrentPage = 1;
      this.deleteModal = false;
    },
    reduceItem(item, index, amount) {
      let myamount = item.amount;
      if (myamount <= amount) {
        this.selectedProducts.splice(index, 1);
      } else {
        this.selectedProducts[index].amount =
          Number(this.selectedProducts[index].amount) - Number(amount);
        this.reactivity = !this.reactivity;
      }
      item.sum = item.sum + amount;
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newInvoice.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.gettingBalance = true;
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            // this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            // let royaltyCreditType = res.data.royaltyCreditType;
            // this.royaltyCreditType =
            //   royaltyCreditType == "normal"
            //     ? "معمولی"
            //     : royaltyCreditType == "vip"
            //     ? "ویژه"
            //     : "فاقد اعتبار";
            this.newInvoice.customerBalance = res.data.balanceData;
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    searchCustomer() {
      this.busy = true;
      let myCustomer = {};
      myCustomer = this.customers.filter(
        (x) => x.mobile == this.customerMobile
      );
      if (myCustomer.length == 0) {
        this.newCustomer = {
          mobile: this.customerMobile,
          type: "naturalPerson",
        };
        this.newCustomerDialog = true;
      } else {
        this.newInvoice.shopCustomerId = myCustomer[0].id;
        this.getBalance(myCustomer[0].id);
      }
      this.busy = false;
    },
    addCustomer() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.getCustomers();
            this.tempCustomer = res.data.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addInvoice() {
      this.vLoading = true;
      this.addBusy = true;
      let itemIds = this.selectedProducts.map((x) => x.id);
      let totalCost;
      let sum =
        this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) *
        (1 + Number(this.newInvoice.vat) / 100);
      if (!this.newInvoice.useCredit) {
        totalCost = parseInt(
          (this.selectedProducts
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) -
            this.newInvoice.discount) *
            (1 + Number(this.newInvoice.vat) / 100)
        );
      } else {
        if (this.royaltyCreditAmount <= sum) {
          totalCost = parseInt(
            (this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) -
              Number(this.royaltyCreditAmount)) *
              (1 + Number(this.newInvoice.vat) / 100)
          );
        } else {
          totalCost = 0;
        }
      }
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/newProforma",
        {
          shopCustomerId: this.newInvoice.shopCustomerId,
          type: "proforma",
          totalCost: totalCost,
          vat: Number(this.newInvoice.vat),
          discount: !this.newInvoice.useRoyaltyCredit
            ? Number(this.newInvoice.discount)
            : undefined,
          itemIds: itemIds,
          details: this.selectedProducts,
          expirationDate: this.newInvoice.expirationDate
            ? this.newInvoice.expirationDate
            : "",
          description: this.newInvoice.descrition
            ? this.newInvoice.descrition
            : "",
          //useRoyaltyCredit: this.useRoyaltyCredit,
          //royaltyDiscount: this.royaltyCreditAmount,
          amount: totalCost,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.addBusy = false;
          if (res.status == 201) {
            this.receiptNumber = res.data.invoiceCode;
            this.newInvoice.shopInvoiceId = res.data.invoiceId;
            // this.toast("فاکتور به ثبت رسید", "success");
            //this.getReceiptDialog = true;
            this.vLoading = false;
            this.invoiceData = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .then(() => {
          this.printReceipt();
          this.$router.push("/shop/proformaList");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.loading = false;
          this.vLoading = false;
          this.addBusy = false;
        });
    },

    printReceipt() {
      //printing receipt
      var myWindow = window.open(
        "#",
        "preInvoiceReceipt",
        "height=auto,width=800"
      );
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(
        document.getElementById("preInvoiceReceipt").innerHTML
      );
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    getProducts() {
      this.productsLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {
          type: this.$route.params.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.productsLoading = false;
          } else {
            this.toast(res.data, "error");
            this.productsLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.productsLoading = false;
        });
    },
    //computedIcon(item) {
    //  if (item.royaltyTier == "coper") {
    //    return "/icons8-star-35(1).png";
    //  } else if (item.royaltyTier == "silver") {
    //    return "/icons8-star-35.png";
    //  } else if (item.royaltyTier == "gold") {
    //    return "/icons8-star-35(2).png";
    //  } else if (item.royaltyTier == "diamond") {
    //    return "/icons8-diamond-35.png";
    //  }
    //},
  },
  computed: {
    computedDiscount() {
      let result;
      parseInt(
        (this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) -
          this.newInvoice.discount) *
          (1 + Number(this.newInvoice.vat) / 100)
      ) > 0
        ? (result =
            parseInt(
              (this.selectedProducts
                .map((x) => Number(x.price) * Number(x.amount))
                .reduce((a, b) => a + b, 0) -
                this.newInvoice.discount) *
                (1 + Number(this.newInvoice.vat) / 100)
            ).toLocaleString() + " ریال ")
        : (result = false);
      return result;
    },
    computedProducts() {
      let filtered;
      filtered = this.products.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) &&
          String(x.barcode).includes(this.barcodeFilter)
      );
      return filtered;
    },
    computedTotalPrice() {
      let total = 0;
      this.selectedProducts.forEach((x) => {
        total = total + Number(x.amount) * Number(x.price);
      });
      this.reactivity = !this.reactivity;
      return total;
    },
  },
  mounted() {
    this.getProducts();
    this.getCustomers();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.checkboxPartial {
  width: fit-content !important;
}
.new-invoice {
  .disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: none !important;
  }
  .customSelect {
    width: 300px;
    border-radius: 8px;
    .v-text-field .v-input__control,
    .v-text-field {
      fieldset {
        height: 48px !important;
        border-radius: 8px !important;
      }
    }
    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }
    }
    .v-label {
      background-color: #fff;
      padding: 2px 6px 0;
    }
  }
  .dashed {
    min-height: 400px;
    .custom-input {
      .v-input__slot {
        width: 100% !important;
      }
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
      .mdi:before {
        margin-top: 6px;
      }
    }
    .customSelect {
      width: 100% !important;
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
    }
  }
  .add-btn {
    width: 30px;
    height: 26px;
    border: 1px solid #12b8a1;
    border-radius: 4px;
    background-color: #edfdf7;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #12b8a1;
    cursor: pointer;
    user-select: none;
  }
  .royaltyCredit label {
    position: static !important;
  }
  .remove-btn {
    min-width: 30px;
    height: 26px;
    border: 1px solid #f3536e;
    border-radius: 4px;
    background-color: FFE4E9;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f3536e;
    cursor: pointer;
    user-select: none;
  }
  .customer-info {
    font-size: 15px;
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 20px 30px;
  }
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;

  .custom-table {
    max-height: 500px;
    overflow-y: auto;
    padding-left: 10px;

    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #979797c7 !important;
      border-radius: 4px !important;
    }
  }
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 50px !important;
    }
    @media only screen and (max-width: 600px) {
      .v-input__slot {
        width: 50% !important;
      }
    }
  }

  .customSelect {
    width: 100%;

    .v-text-field .v-input__control,
    .v-text-field {
      fieldset {
        height: 48px !important;
      }
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }
    }
    .v-label {
      background-color: #fff;
      padding: 2px 6px 0;
    }
  }

  .purple-icon {
    path {
      stroke: #7634d6;
    }
  }
}
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.v-dialog {
  overflow-y: hidden !important;
}
</style>
